module.exports = __webpack_public_path__ + "media/flags/ie-793ac951.svg";